// Correct single import
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Building2, Plus } from 'lucide-react';
import './Company.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;



const AddCompany = () => {
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    companyname: "",
    acronym: "",
    companytype: "",
    currentmanager: "",
    contact: "",
    companylocation: "",
    companylogo: null,
    companyseal: null,
    companysignature: null,
  });
  const [focusedFields, setFocusedFields] = useState({});
  const navigate = useNavigate();

  const handleFocus = (field) => {
    setFocusedFields(prev => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusedFields(prev => ({
      ...prev,
      [field]: !!data[field], // true if not empty/null
    }));
  };

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;
    if (files) {
      setData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setData(prev => ({ ...prev, [name]: value }));
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!data.companyname.trim() || !data.companytype.trim()) {
      toast.error("Company name and type are required");
      return;
    }

    try {
      setSubmitting(true);

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== "") {
          formData.append(key, data[key]);
        }
      });

      const response = await axios.post(
        `${url}/api/company`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.success) {
        toast.success("Company added successfully!");
        setData({
          companyname: "",
          acronym: "",
          companytype: "",
          currentmanager: "",
          contact: "",
          companylocation: "",
          companylogo: null,
          companyseal: null,
          companysignature: null,
        });
        navigate("/ViewCompany");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to add company";
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="company-form-container">
        <h2 className="form-title">
          <Building2 size={20} className="inline mr-2" /> Add New Company
        </h2>
        <div className="header">
          <button 
            onClick={() => navigate("/ViewCompany")}
            className="add-button"
          >
            <Plus size={16} /> View Companies
          </button>
        </div>

        <form className="company-form" onSubmit={onSubmitHandler} encType="multipart/form-data">
          {["companyname", "acronym", "companytype", "currentmanager", "contact", "companylocation"].map((field) => (
            <div key={field} className={`form-field ${focusedFields[field] || data[field] ? "filled" : ""}`}>
              <input
                type="text"
                name={field}
                value={data[field]}
                onChange={onChangeHandler}
                onFocus={() => handleFocus(field)}
                onBlur={() => handleBlur(field)}
                required={field === "companyname" || field === "companytype"}
              />
              <label>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
            </div>
          ))}

          {["companylogo", "companyseal", "companysignature"].map((fileField) => (
            <div key={fileField} className="form-field file-input">
              <label>{fileField.replace("company", "").replace(/([A-Z])/g, ' $1')}</label>
              <input type="file" name={fileField} accept="image/*" onChange={onChangeHandler} />
            </div>
          ))}

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Processing..." : "Add Company"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddCompany;
